import React, {
  useRef,
  useEffect,
  useState,
  useReducer,
  useContext,
} from "react";
import { useTranslation } from "react-i18next";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Form, FormElement } from "@progress/kendo-react-form";
import "../signature-request-detail/dialog-sign.css";

import CanvasDraw from "@win11react/react-canvas-draw";
import { PDFDocument } from "pdf-lib";
import { Document, Page, pdfjs } from "react-pdf";
import P5ContainerVolume from "../signature-request-detail/P5ContainerVolume";
import { useMediaQuery } from "@material-ui/core";
import { Context } from "../../../Context";
import { LocalStorageService } from "../../../services/index";
import { getStampTimeAndTimezone } from "../../../utils";
import ButtonHLPure from "../buttonHL/buttonHL.pure";
import { InstructionsPure } from "../../pures";

const gotToEnd = () => {
  let out = document.getElementsByClassName("k-dialog-content");
  out[0].scrollTop = out[0].scrollHeight * 0.7;
};

const saveImage = (activeStroke = false) => {
  let sourceCanvas = document.getElementsByTagName("canvas")[1];
  let destinationCanvas = document.createElement("canvas");
  destinationCanvas.height = sourceCanvas.height;
  destinationCanvas.width = sourceCanvas.width;
  let destinationContext = destinationCanvas.getContext("2d");
  if (activeStroke) {
    destinationContext.strokeStyle = "#427FBA";
    destinationContext.lineWidth = 5;
    destinationContext.strokeRect(
      0,
      0,
      sourceCanvas.width,
      sourceCanvas.height
    );
  }
  destinationContext.drawImage(sourceCanvas, 0, 0);
  destinationContext.globalCompositeOperation = "destination-over";
  destinationContext.fillStyle = "#4484a500";
  destinationContext.fillRect(
    0,
    0,
    destinationCanvas.width,
    destinationCanvas.height
  );
  let image = destinationCanvas.toDataURL("image/png");

  return {
    newImg: image,
    imageWidth: destinationCanvas.width,
    imageHeight: destinationCanvas.height,
  };
};

function setTextInCanvas(x, y, text) {
  try {
    let sourceCanvas = document.getElementsByTagName("canvas")[1];
    let ctx = sourceCanvas.getContext("2d");
    ctx.font = "bold 25px Arial";
    ctx.textAlign = "center";
    ctx.fillText(text, sourceCanvas.width / 2, y);
  } catch (error) { }
}

const initialValuesState = {
  activeOnSubit: false,
  signatureData: {},
};

function valuesReducerActions(state, action) {
  switch (action.type) {
    case "setActiveOnSubit":
      return { ...state, activeOnSubit: action.data };
    default:
      throw new Error();
  }
}

const DialogAcceptSignatureAutographReliable = (props) => {
  const { setCanvasData, setShowSignatureCanvas } = useContext(Context);
  // let name = props?.currentUserName ?? "";
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [currentSystem, setCurrentSystem] = useState("");
  const { t } = useTranslation();
  const pad = useRef(null);
  const [step, setStep] = useState("sign");
  const [pagesSize, setPagesSize] = useState([]);
  const [imgSignature, setImgSignature] = useState(null);
  const [widthImgSignature, setWidthImgSignature] = useState(400);
  const [heightImgSignature, setHeightImgSignature] = useState(300);
  const [pagesImgs, setPagesImgs] = useState([]);
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pager, setPager] = useState(1);
  const [divGreyTextSize, setdivGreyTextSize] = useState(700);
  const greyTextRef = useRef(null);
  const [tempImgPages, setTempImgPages] = useState({});
  const [userInfo, setUserInfo] = useState({});
  const [didMount, setDidMount] = useState(null)
  const [values, dispatchValues] = useReducer(
    valuesReducerActions,
    initialValuesState
  );
  let pdfFile =
    "data:application/pdf;filename=file.pdf;base64," + props.pdfFileBase64;
  let greyText =
    step === "sign"
      ? "dialogAcceptSignature.noticeCreateSignAutografa"
      : "dialogAcceptSignature.noticeCreateSignAutografaCustom";
  let infodevice = currentSystem.toLowerCase();
  let isMobile = infodevice.includes("android");
  isMobile = isMobile || infodevice.includes("iphone");
  isMobile = isMobile || infodevice.includes("ipad");
  isMobile = isMobile || infodevice.includes("mobile");
  function isTouchScreendevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
  }

  if (isTouchScreendevice()) {
    isMobile = true;
  }
  useEffect(() => {
    const divGreyText = greyTextRef.current;
    if (divGreyText) {
      if (divGreyText.clientWidth) {
        setdivGreyTextSize(divGreyText.clientWidth);
      }
    }
  }, [props.visibleAccept]);
  useEffect(() => {
    let tempArr = [...Array(numPages)];
    for (const key in tempImgPages) {
      tempArr[Number(key)] = tempImgPages[key];
    }
    setPagesImgs(tempArr);
  }, [tempImgPages]);
  const getPdgPageSize = async () => {
    const pdfDoc = await PDFDocument.load(pdfFile);
    const pages = pdfDoc.getPages()
    let sizes = pages.map((i) => i.getSize());
    setPagesSize(sizes);
  };
  const onDocumentLoadSuccess = (params) => {
    setNumPages(params.numPages);
    setPageNumber(params.numPages);
    setPager(params.numPages);
  };

  const changePage = (offset) => {
    setPageNumber((prevPageNumber) => prevPageNumber + offset);
    setPager((prevPageNumber) => prevPageNumber + offset);
  };

  const previousPage = () => {
    if (pageNumber <= 1) return;
    changePage(-1);
  };

  const nextPage = () => {
    if (pageNumber >= numPages) return;
    changePage(1);
  };

  useEffect(() => {
    setCurrentSystem(navigator.userAgent);
  }, []);

  useEffect(() => {
    let localStorageService = new LocalStorageService();
    let userInfo = localStorageService.getLocalStorageItem("user").userMetaData;
    let tokenUserNames = `${userInfo.userA3Cloud.firstName}`;
    let tokenUserLastnames = `${userInfo.userA3Cloud.firstLastName} ${userInfo.userA3Cloud.secondLastName}`;
    setUserInfo({ tokenUserNames, tokenUserLastnames });
  }, [didMount]);

  useEffect(() => {
    if (props.pdfFileBase64) getPdgPageSize();
  }, [props.pdfFileBase64]);
  useEffect(() => {
    if (
      props.visibleAccept &&
      !props.showLoadingRequesting &&
      // props.currentSignaturetype.id ===
      // Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA)
      // &&
      step === "sign"
    ) {
      setTimeout(() => {
        setTextInCanvas(100, 255, "");
        setTextInCanvas(100, 275, "");
      }, 100);
    }
  }, [props.visibleAccept, step]);

  let pagesNumTemp = [...Array(numPages)];
  const isPhone = useMediaQuery("(max-width:500px)");

  const { innerWidth: fullWidth } = window;
  if (isMobile)
    greyText = "dialogAcceptSignature.noticeCreateSignAutografaMobile";

  let instructions = [t(greyText)]
  if(step === "sign") instructions.push(t("dialogAcceptSignature.noticeCreateSignAutografa2"))
  return (  
    <div>
      {/* {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? ( */}
      <div className="dialogContent">
        {/* {props.authorizerCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
              <button
                className={"form-button-accept"}
                type="submit"
                style={{ marginLeft: "8px" }}
                onClick={() => props.setIsShowAutorizationModal()}
              >
                {"Autorizar"}
              </button>
            )} */}
        {/* {
          props.userCanSign &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && ( */}
        <button
          className="form-button-accept"
          style={{ marginLeft: "8px" }}
          onClick={props.toggleDialogAccept}
        >
          {t("button.sign")}
        </button>
        {/* )} */}
        {/* {props.visibleAccept && */}
        {/* // !props.showLoadingRequesting && */}
        {/* // props.currentSignaturetype.id === */}
        {/* // Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && ( */}
        <Dialog
          title={t("dialogAcceptSignature.titleAcceptSignRequest", {
            signatureType: props.title,
          })}
          onClose={props.onDeleteDataAccept}
          // width={"auto"}
          className="dialog-signature"
          width={'800px'}
        // style={{ maxWidth: '800px', margin: 'auto' }}
        >
          <div className={(step === "sign") ? "dialogAcceptSignatureAutographReliable-instructions-sign" : "dialogAcceptSignatureAutographReliable-instructions-saved"}>
            <InstructionsPure instructions={instructions} />
          </div>
          <div>
            <Form
              style={{ margin: "0px" }}
              onSubmit={props.onSubmit}
              allowSubmit={true}
              className="formCustomSignature"
              valid={true}
              touched={true}
              visited={true}
              render={(formRenderProps) => {
                let disabled = false;
                return (
                  <FormElement
                    style={{
                      maxWidth: "450px !important",
                      width: "100%",
                      margin: "auto",
                    }}
                  >
                    <div>
                      {step === "sign" && (
                        <div className={"signatureCredretialForm-canvas-draw"}>
                          <CanvasDraw
                            ref={pad}
                            loadTimeOffset={0}
                            lazyRadius={2}
                            brushRadius={2}
                            brushColor={"#000"}
                            catenaryColor={"#0a0302"}
                            gridColor={"rgba(150,150,150,0.17)"}
                            hideGrid={true}
                            canvasWidth={705}
                            canvasHeight={300}
                            disabled={false}
                            immediateLoading={true}
                            hideInterface={false}
                          />
                        </div>
                      )}
                      {step === "location" && (
                        <div
                          style={{
                            width: pagesSize[0].width + 16,
                            height: pagesSize[0].height + 16,
                          }}
                        >
                          <div
                            item
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                          >
                            <span
                              class="k-icon k-i-arrow-double-60-left icon-bar"
                              style={{ color: "#427FBA" }}
                              onClick={() => {
                                setPageNumber(1);
                                setPager(1);
                              }}
                            ></span>
                            <span
                              class="k-icon k-i-arrow-60-left icon-bar"
                              style={{ color: "#427FBA" }}
                              onClick={previousPage}
                            ></span>
                            <div
                              className="pagec"
                              style={{
                                color: "#427FBA !impotant",
                                textAlign: "center",
                                fontWeight: "bold",
                                marginTop: "auto",
                                marginBottom: "auto",
                                padding: '0px 5px'
                              }}
                            >
                              Página
                              <input
                                style={{
                                  width: "32px",
                                  marginLeft: "4px",
                                  marginRight: "3px",
                                }}
                                type="text"
                                value={pager}
                                onChange={({ target }) => {
                                  setPager(Number(target.value));
                                  if (Number(target.value) <= numPages) {
                                    if (Number(target.value) <= 0) {
                                      setPageNumber(1);
                                      setPager(1);
                                    } else setPageNumber(Number(target.value));
                                  } else
                                    setTimeout(() => {
                                      setPager(pageNumber);
                                    }, 1000);
                                }}
                              />
                              de {numPages || "--"}
                            </div>
                            <span
                              class="k-icon k-i-arrow-60-right icon-bar"
                              style={{ color: "#427FBA" }}
                              onClick={nextPage}
                            ></span>
                            <span
                              class="k-icon k-i-arrow-double-60-right icon-bar"
                              style={{ color: "#427FBA" }}
                              onClick={() => {
                                setPageNumber(numPages);
                                setPager(numPages);
                              }}
                            ></span>
                          </div>
                          {pagesImgs.map((item, index) => (
                            <React.Fragment key={String(index)}>
                              <div
                                style={
                                  index === pageNumber - 1
                                    ? {}
                                    : { display: "none" }
                                }
                              >
                                <P5ContainerVolume
                                  tFunction={t}
                                  base64Img={item}
                                  widthImg={pagesSize[index].width}
                                  heightImg={pagesSize[index].height}
                                  imgSignature={imgSignature}
                                  // widthImgSignature={
                                  //   (widthImgSignature / 2) * 0.8
                                  // }
                                  // heightImgSignature={
                                  //   (heightImgSignature / 2) * 0.8
                                  // }
                                  widthImgSignature={widthImgSignature}
                                  heightImgSignature={heightImgSignature}
                                  pageNumber={index}
                                  save={(params) => {
                                    let temp = {
                                      ...params,
                                      page: index + 1,
                                    };
                                    props.setSignatureImgeData(temp);
                                    props.onDeleteDataAccept();
                                  }}
                                  activeOnSubit={values.activeOnSubit}
                                  signatureData={values.signatureData}
                                  dispatchValues={dispatchValues}
                                  back={() => setStep("sign")}
                                  cancel={() => {
                                    setStep("sign");
                                    props.onDeleteDataAccept();
                                  }}
                                  isMobile={false}
                                  gotToEnd={gotToEnd}
                                  isPhone={isPhone}
                                  yCoordinates={220}
                                  xCoordinates={180}
                                  disable={true}
                                />
                              </div>
                            </React.Fragment>
                          ))}
                        </div>
                      )}
                      {step === "sign" && (
                        <div
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sm={12}
                          es={12}
                          className={`button-dialog-accept button-dialog-accept-size 
                                ${step === "location" &&
                            "button-on-custom-signature"
                            }
                                  `}
                        >
                          <div className="btn-container-fiable">
                            <ButtonHLPure
                              nameBtn={t("dialogAcceptSignature.close")}
                              onClickBtn={props.onDeleteDataAccept}
                              primary={false}
                            />
                            <ButtonHLPure
                              nameBtn={t("dialogAcceptSignature.clean")}
                              onClickBtn={() => {
                                props.setImgSignature(null);
                                pad.current.clear();
                                setTimeout(() => {
                                  setTextInCanvas(100, 255, "");
                                  setTextInCanvas(100, 275, "");
                                }, 0);
                                setTimeout(
                                  () => props.setImgSignature(saveImage()),
                                  10
                                );
                              }}
                              primary={false}
                            />
                            <ButtonHLPure
                              nameBtn={t("dialogAcceptSignature.captureSignature")}
                              onClickBtn={async () => {
                                const stampTime = await getStampTimeAndTimezone()
                                if (stampTime === false) {
                                  props.onErrorTimeStamp()
                                  return false
                                }
                                // setTextInCanvas(100, 295, moment().format("YYYY-MM-DD") + " " + moment().format("HH:mm:ss"));
                                setTextInCanvas(
                                  100,
                                  265,
                                  `${userInfo.tokenUserNames} ${userInfo.tokenUserLastnames}`
                                );
                                setTextInCanvas(
                                  100,
                                  295,
                                  `${stampTime}`
                                );
                                setTimeout(() => {
                                  let { newImg, imageWidth, imageHeight } =
                                    saveImage();
                                  setImgSignature(newImg);
                                  if (isMobile) {
                                    let imgSignatureStroke = saveImage(true);
                                    setCanvasData({
                                      imgSignature: imgSignatureStroke.newImg,
                                      pagesImgs,
                                      numPages,
                                      pagesSize,
                                      pager,
                                      pageNumber,
                                      greyText: t(
                                        "dialogAcceptSignature.noticeCreateSignAutografaCustomMobile"
                                      ),
                                      widthImgSignature,
                                      heightImgSignature,
                                      page: pageNumber,
                                      back: () => {
                                        props.onDeleteDataAccept();
                                        setTimeout(() => {
                                          props.toggleDialogAccept();
                                        }, 100);
                                      },
                                      save: (params) => {
                                        let signatureImgeData = {
                                          ...params,
                                        };
                                        setStep("sign");
                                        setShowSignatureCanvas(false);
                                        props.setSignatureImgeData(
                                          signatureImgeData
                                        );
                                      },
                                    });
                                  }
                                  props.setImgSignature({
                                    imgSignature: newImg,
                                    imageWidth,
                                    imageHeight,
                                  });
                                  setWidthImgSignature(imageWidth);
                                  setHeightImgSignature(imageHeight);
                                  if (isMobile) {
                                    setShowSignatureCanvas(true);
                                  } else setStep("location");
                                }, 0);
                              }}
                              primary={true}
                              disabled={disabled}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </FormElement>
                );
              }}
            />
          </div>
        </Dialog>
        {/* // ) */}
        {/* // } */}
      </div>
      {/* // ) : null} */}
      <div style={{ display: "none" }}>
        <Document file={pdfFile} onLoadSuccess={onDocumentLoadSuccess}>
          <React.Fragment>
            {pagesNumTemp.map((item, index) => (
              <React.Fragment>
                <Page
                  className={`import-pdf-page-${index + 1}`}
                  pageNumber={index + 1}
                  onRenderSuccess={() => {
                    const importPDFCanvas = document.querySelector(
                      `.import-pdf-page-${index + 1} canvas`
                    );
                    const pdfAsImageSrc = importPDFCanvas.toDataURL();
                    if (!tempImgPages[index]) {
                      setTempImgPages({
                        ...tempImgPages,
                        [index]: pdfAsImageSrc,
                      });
                    }
                  }}
                />
              </React.Fragment>
            ))}
          </React.Fragment>
        </Document>
      </div>
    </div>
  );
};

export { DialogAcceptSignatureAutographReliable as default };
